import request from '../axios';

export const getBuyers = async (
  order: string,
  page: number,
  newSearch: string,
  app: string,
) => {
  const {data}: {data: IBuyers} = await request.get(
    `/api/v2/market/wanted-post-list?page=${page}&order_by=${order}&search=${newSearch}&app=${app}`,
  );
  return data;
};
